import Vue         from 'vue';
import Transfer    from "@/modules/core/service/private/Transfer";
import Methods     from "@/modules/core/service/private/Methods";
import Messages    from "@/modules/core/service/private/Messages";
import Formater    from "@/modules/core/service/private/Formater";
import Navigation  from "@/modules/core/service/private/Navigation";
import Preferences from "@/modules/core/service/private/Preferences";
import Fire        from "@/modules/core/service/private/Fire";
import Filter      from "@/modules/core/service/private/Filter";
import Roles       from "@/modules/core/service/private/Roles";
import Validation  from "@/modules/core/service/private/Validation";
import Loader      from "@/modules/core/service/private/Loader";
import Security    from "@/modules/core/service/private/Security";
import Scroll      from "@/modules/core/service/private/Scroll";
import Download from "@/modules/core/service/private/Download";

export default {
    bus        : new Vue(),
    transfer   : Transfer,
    method     : Methods,
    message    : Messages,
    format     : Formater,
    nav        : Navigation,
    preferences: Preferences,
    fire       : Fire,
    filter     : Filter,
    role       : Roles,
    rule       : Validation,
    init       : Loader,
    security   : Security,
    scroll     : Scroll,
    download   : Download,

    log (data) {
        console.log(data)
    },

    map: {
        centerGermany () {
            return {
                lat: 50.984501787212295,
                lng: 9.697256043590855
            }
        }
    },

    data: {
        clone (data) {
            return JSON.parse(JSON.stringify(data));
        },
    },

    loading (component, value, message) {
        component.$bus.$emit(component.$events.loading, {
            value  : value,
            message: message
        });
    },
}